"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveNarrationPartsV2 = exports.generateRecordingAssetId = exports.limitMockText = void 0;
const traverse_1 = __importDefault(require("traverse"));
const md5_1 = __importDefault(require("md5"));
const js_base64_1 = require("js-base64");
const narration_service_types_1 = require("@sundaysky/narration-service-types");
const pronunciationUtils_1 = require("./pronunciationUtils");
// Narration-Service endpoint
const narrationServiceEndpoint = process.env.HUB_NARRATION_SERVICE_ENDPOINT;
const MOCK_TEXT_LIMIT = 1024;
const MOCK_TEXT_TRUNCATED_NOTICE = ". Truncated";
const limitMockText = (text, limit = MOCK_TEXT_LIMIT) => {
    if (text.length <= limit) {
        return text;
    }
    const lastIndexOfSpace = text.lastIndexOf(" ", limit - MOCK_TEXT_TRUNCATED_NOTICE.length);
    const index = lastIndexOfSpace > 0 ? lastIndexOfSpace : limit - MOCK_TEXT_TRUNCATED_NOTICE.length;
    const truncated = text.substring(0, index);
    return `${truncated}${MOCK_TEXT_TRUNCATED_NOTICE}`;
};
exports.limitMockText = limitMockText;
const buildResolverUrl = (narrationPartObj, resolverRecordingBaseUrl, narrationProps) => {
    const { transcript } = narrationPartObj;
    const recordingAssetId = (0, exports.generateRecordingAssetId)(narrationPartObj);
    const resolverUrl = `${resolverRecordingBaseUrl}${recordingAssetId}`;
    let queryParams = `text=${js_base64_1.Base64.encode((0, exports.limitMockText)(transcript), true)}`;
    if (narrationProps) {
        for (const key in narrationProps) {
            queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(narrationProps[key])}`;
        }
    }
    queryParams += "&filename=any.mp3";
    return `${resolverUrl}?${queryParams}`;
};
const getNarrationServiceUrl = (narrationPartObj, narrationProps) => {
    const { transcript } = narrationPartObj;
    const text = js_base64_1.Base64.encode((0, exports.limitMockText)(transcript), true);
    const input = Object.assign(Object.assign({}, narrationProps), { text });
    return (0, narration_service_types_1.buildNarrationServiceUrl)(narrationServiceEndpoint, input);
};
const generateRecordingAssetId = (narrationPartObj) => {
    const { narrationId, narrator, transcript, rate } = narrationPartObj;
    let key = `${narrationId}~${narrator}~${(0, md5_1.default)(transcript)}`;
    if (rate && rate !== 1) {
        key += `~${rate}`;
    }
    return key;
};
exports.generateRecordingAssetId = generateRecordingAssetId;
const isNarrationPart = (elem) => {
    return (elem === null || elem === void 0 ? void 0 : elem.type) === "narration";
};
/**
 * Scans for narration parts and inline with URLs to resolver
 *
 * @param lineup lineup
 * @param narrator narrator
 * @param repos repositories
 * @param pronunciationDefinitions pronunciation definitions
 */
const resolveNarrationPartsV2 = (lineup, narrator, repos, pronunciationDefinitions = []) => {
    const { recording } = repos;
    lineup.forEach((scene) => {
        (0, traverse_1.default)(scene.data).forEach(function (elem) {
            var _a;
            if (isNarrationPart(elem)) {
                const { transcript, isRealtimeNarration, fallbackTranscript, narrationId } = elem;
                if (transcript) {
                    const rate = (_a = elem["@narrationProps"]) === null || _a === void 0 ? void 0 : _a.rate;
                    if (isRealtimeNarration) {
                        const transcriptAfterPronunciation = (0, pronunciationUtils_1.applyPronunciationDefinitionsToVoiceOverText)(transcript, pronunciationDefinitions);
                        this.parent.node[this.key] = {
                            source: getNarrationServiceUrl({ narrationId, narrator, transcript: transcriptAfterPronunciation }, elem["@narrationProps"]),
                            transcript: transcriptAfterPronunciation,
                            ["@narrationProps"]: Object.assign({}, elem["@narrationProps"])
                        };
                        if (fallbackTranscript) {
                            const fallbackTranscriptAfterPronunciation = (0, pronunciationUtils_1.applyPronunciationDefinitionsToVoiceOverText)(fallbackTranscript, pronunciationDefinitions);
                            // We assume that the fallback is not a realtime narration, but a pre-created one
                            this.parent.node[this.key].fallback = {
                                source: getNarrationServiceUrl({ narrationId, narrator, transcript: fallbackTranscriptAfterPronunciation }, elem["@narrationProps"]),
                                transcript: fallbackTranscriptAfterPronunciation
                            };
                        }
                        else {
                            // This makes sure we don't fail in runtime if the fallback is not defined
                            this.parent.node[this.key].fallback = "";
                        }
                    }
                    else {
                        this.parent.node[this.key] = {
                            source: buildResolverUrl({ narrationId, narrator, transcript, rate }, recording, elem["@narrationProps"]),
                            transcript,
                            ["@narrationProps"]: Object.assign({}, elem["@narrationProps"])
                        };
                    }
                }
                else {
                    this.parent.node[this.key] = null;
                }
                if (this.parent.node[this.key] && elem["@style"]) {
                    this.parent.node[this.key] = Object.assign(Object.assign({}, this.parent.node[this.key]), { ["@type"]: "media", ["@styleProps"]: elem["@style"]["@styleProps"] });
                }
            }
        });
    });
};
exports.resolveNarrationPartsV2 = resolveNarrationPartsV2;
//# sourceMappingURL=narrations2.js.map